export default __webpack_public_path__ + "static/media/recomposer-lite.b52036c8.png";